import { iconSetQuartzRegular, themeQuartz } from 'ag-grid-community';
import { colors } from './colors';
import { isNewUi, radius } from './ui-version';

export const agBorderColor = isNewUi ? colors.border.default : colors.neutral[20];

const legacyParams = {
  accentColor: colors.secondary[50],
  backgroundColor: colors.primary[0],
  borderColor: agBorderColor,
  borderRadius: radius,
  valueChangeValueHighlightBackgroundColor: colors.secondary[10],
  cellWidgetSpacing: '12px',
  checkboxBorderRadius: '2px',
  checkboxIndeterminateBackgroundColor: '#B2B2BD',
  checkboxIndeterminateBorderColor: '#B2B2BD',
  columnBorder: false,
  columnDropCellBackgroundColor: '#E4E6FF',
  columnDropCellBorder: false,
  dropdownShadow: '#00000049 0px 4px 10px 0px',
  // AG Grid 36 defaults this to 400; keep the page's weight, as before v36
  fontWeight: 'inherit',
  foregroundColor: 'rgba(0, 0, 0, 0.87)',
  headerBackgroundColor: '#F8F8FB',
  headerCellBackgroundTransitionDuration: '0.1s',
  headerCellHoverBackgroundColor: '#E4E4EB3D',
  headerColumnBorder: true,
  headerColumnBorderHeight: '100%',
  headerColumnResizeHandleColor: '#E4E8F200',
  headerFontSize: 14,
  headerFontWeight: 600,
  headerRowBorder: true,
  headerTextColor: '#090C0Eee',
  headerVerticalPaddingScale: 1,
  iconButtonHoverBackgroundColor: '#A9A9AC29',
  iconButtonHoverColor: '#B1B1BD38',
  iconSize: '16px',
  inputBorderRadius: '0px',
  inputFocusBorder: false,
  menuBackgroundColor: '#FBFCFD',
  menuBorder: false,
  menuShadow: '#00000049 0px 4px 10px 0px',
  oddRowBackgroundColor: '#FBFCFD',
  rowBorder: true,
  sidePanelBorder: true,
  spacing: '8px',
  toolPanelSeparatorBorder: true,
  wrapperBorder: true,
  wrapperBorderRadius: radius,
};

// The New UI: white headers with grey capitals, hairlines everywhere, no shadows (floating
// panels get a 1px edge), a lilac Total row, grey header icons that darken on hover.
const newUiParams = {
  ...legacyParams,
  checkboxIndeterminateBackgroundColor: colors.neutral[30],
  checkboxIndeterminateBorderColor: colors.neutral[30],
  columnDropCellBackgroundColor: colors.primary[10],
  dropdownShadow: 'none',
  foregroundColor: 'rgba(24, 22, 48, 0.87)',
  headerBackgroundColor: colors.surface.card,
  headerCellHoverBackgroundColor: '#E9E9F23D',
  headerColumnResizeHandleColor: '#E9E9F200',
  headerFontSize: 12,
  headerTextColor: colors.text.secondary,
  iconButtonColor: colors.icon.secondary,
  iconButtonHoverBackgroundColor: colors.primary[10],
  iconButtonHoverColor: colors.icon.main,
  iconButtonActiveBackgroundColor: colors.primary[10],
  iconButtonActiveColor: colors.icon.main,
  iconButtonActiveIndicatorColor: colors.icon.link,
  menuBackgroundColor: colors.surface.card,
  menuBorder: true,
  menuShadow: 'none',
  oddRowBackgroundColor: colors.surface.tableStripe,
  pinnedRowBackgroundColor: colors.surface.tableTotal,
  pinnedRowTextColor: colors.text.main,
  pinnedRowFontWeight: 600,
};

// to use myTheme in an application, pass it to the theme grid option
export const agForesightTheme = themeQuartz
  .withParams(isNewUi ? newUiParams : legacyParams)
  .withPart(iconSetQuartzRegular);

export const agForesightCompactTheme = agForesightTheme.withParams({
  spacing: '4px',
  headerFontSize: 12,
});

/**
 * A table that is a page's own card has no outer stroke in the New UI, like page cards; a table
 * nested in a card keeps agForesightTheme's hairline.
 */
export const agForesightPageTheme = isNewUi
  ? agForesightTheme.withParams({ wrapperBorder: false })
  : agForesightTheme;
